import { render, staticRenderFns } from "./detection-dialog.vue?vue&type=template&id=b2da8244&"
import script from "./detection-dialog.vue?vue&type=script&lang=js&"
export * from "./detection-dialog.vue?vue&type=script&lang=js&"
import style0 from "./detection-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports